import EnsName from '@/components/utils/ens-name'
import { PartialProposal } from '@/lib/governance'
import { chainIdAtom } from '@/state/atoms'
import { formatDate } from '@/utils'
import { ExplorerDataType, getExplorerLink } from '@/utils/getExplorerLink'
import { Trans } from '@lingui/react/macro'
import { useAtomValue } from 'jotai'
import { Link } from 'react-router-dom'

export const RebalanceItemFooter = ({
  proposal,
}: {
  proposal: PartialProposal
}) => {
  const chainId = useAtomValue(chainIdAtom)

  return (
    <div className="flex items-center gap-2 border-t border-secondary p-4 md:p-6">
      <div className="flex items-center gap-1 text-sm mr-auto">
        <span className="text-legend">
          <Trans>Proposed:</Trans>
        </span>
        <Link
          onClick={(e) => e.stopPropagation()}
          to={getExplorerLink(
            proposal.proposer.address,
            chainId,
            ExplorerDataType.ADDRESS
          )}
          className="underline"
          target="_blank"
        >
          {formatDate(proposal.creationTime * 1000)}
        </Link>
      </div>
      <div className="items-center gap-1 text-sm hidden sm:flex">
        <span className="text-legend">
          <Trans>Proposed by:</Trans>
        </span>
        <Link
          onClick={(e) => e.stopPropagation()}
          to={getExplorerLink(
            proposal.proposer.address,
            chainId,
            ExplorerDataType.ADDRESS
          )}
          target="_blank"
        >
          <EnsName address={proposal.proposer.address} />
        </Link>
      </div>
    </div>
  )
}
